var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivilegeSuccessPatternMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 90,
    viewBox: "0 0 290 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.496 125.857C374.794 126.225 376.15 126.717 377.416 127.177C445.841 152.012 481.132 227.555 456.286 296.008C431.441 364.461 355.913 399.782 287.487 374.947C219.061 350.111 183.771 274.569 208.616 206.115C214.688 189.386 223.842 174.595 235.092 162.201",
    stroke: "white",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.533 170.31C265.055 161.102 262.478 149.318 265.003 137.852C265.355 136.035 265.921 134.194 266.545 132.476C274.356 110.954 298.103 99.9241 319.526 107.7C326.305 110.16 332.099 114.208 336.497 119.283C344.085 127.973 347.853 139.575 346.445 151.344",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.427 192.887C242.242 183.934 237.381 173.368 235.092 162.201C232.564 149.719 233.371 136.503 238.031 123.663C238.819 121.493 239.697 119.355 240.633 117.341C256.293 84.3406 294.752 68.007 329.824 80.7364C336.241 83.0657 342.06 86.2009 347.254 89.9282C359.73 98.9594 368.765 111.552 373.406 125.824C377.01 136.752 378.001 148.676 375.862 160.487",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.269 165.601C181.964 154.687 176.928 136.997 182.901 120.539C186.478 110.683 193.467 102.985 202.017 98.3107C206.338 95.9899 211.003 94.4085 215.892 93.6242C222.456 92.7318 229.316 93.2774 235.915 95.6724C237.271 96.1645 238.684 96.7798 240.007 97.3624",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.353 202.341C146.731 182.426 132.647 143.44 145.677 107.54C155.326 80.9546 177.566 62.5208 203.213 56.6834C204.295 51.4474 205.772 46.2523 207.675 41.0075C229.698 -19.669 296.725 -51.0139 357.377 -29C417.939 -7.01897 449.232 59.8069 427.456 120.368",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.056 111.01C236.858 93.354 235.904 73.1538 242.928 53.8024C257.894 12.5678 303.359 -8.6938 344.577 6.26645C383.716 20.4721 404.875 62.231 394.033 101.687",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.333 91.5938C259.463 81.807 260.074 71.3856 263.717 61.3482C274.515 31.5977 307.29 16.271 337.028 27.0647C364.778 37.1366 380 66.5064 373.079 94.5939",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.379 78.7375C287.608 75.8527 288.141 72.9758 289.191 70.0822C295 54.0766 312.619 45.837 328.619 51.644C344.256 57.3197 352.414 74.3012 347.435 89.9939L347.344 89.9611C360.696 91.2251 374.032 94.2233 387.138 98.9804C471.292 129.524 514.699 222.443 484.143 306.631C453.587 390.818 360.686 434.263 276.532 403.719C192.379 373.175 148.971 280.257 179.527 196.069C191.605 162.792 213.463 135.828 240.633 117.341",
    stroke: "white",
    strokeWidth: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.988 112.159C431.798 59.9265 404.428 3.4283 352.454 -15.436C299.304 -34.7269 240.532 -7.24244 221.234 45.9286C220.184 48.8223 219.224 51.7487 218.477 54.6504C217.124 59.7879 216.133 65.0567 215.568 70.2758C210.507 70.6904 205.611 71.7788 200.855 73.3274C182.627 79.2991 167.196 93.3475 160.106 112.88C149.998 140.731 160.085 171.001 182.916 187.577",
    stroke: "white",
    strokeWidth: 15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegeSuccessPatternMobile);
export default __webpack_public_path__ + "static/media/privilege-success-pattern-mobile.0106aeba.svg";
export { ForwardRef as ReactComponent };